<template>
    <div v-if="usuario">
        <Box @close="cerrar(false)">
            <template #top>Modificar Usuario</template>
            <template #center>
                <div class="nj-card nj-cols form c2 l-c3">
                    <div>
                        <div class="nj-label">Tipo</div>
                        <select class="nj-select"
                                v-model="usuario.tiu_id">
                            <option v-for="item in tipos_usaurio"
                                    :key="item.tiu_id"
                                    :value="item.tiu_id">{{ item.tiu_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Nombre</div>
                        <input type="text"
                               class="nj-text"
                               v-model="usuario.usu_nombre">
                    </div>
                    <div>
                        <div class="nj-label">Apellido</div>
                        <input type="text"
                               class="nj-text"
                               v-model="usuario.usu_apellido">
                    </div>
                    <div>
                        <div class="nj-label">DNI</div>
                        <input type="text"
                               class="nj-text"
                               v-model="usuario.usu_dni"
                               disabled>
                    </div>
                    <div>
                        <div class="nj-label">Correo electrónico</div>
                        <input type="text"
                               class="nj-text"
                               v-model="usuario.usu_correo">
                    </div>
                    <div>
                        <div class="nj-label">Password</div>
                        <input type="password"
                               class="nj-text"
                               v-model="usuario.usu_password">
                    </div>
                    <div>
                        <div class="nj-label">Nivel</div>
                        <select class="nj-select"
                                v-model="usuario.usu_nivel">
                            <option v-for="item in lista_usuario_nivel"
                                    :key="item.niu_id"
                                    :value="item.niu_id">{{ item.niu_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Roles</div>
                        <select class="nj-select"
                                multiple
                                v-model="id_roles">
                            <option v-for="item in roles"
                                    :key="item.rol_id"
                                    :value="item.rol_id">{{ item.rol_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Firma</div>
                        <b-upload v-model="firma"
                                  @input="adjuntarFirma()">
                            <div class="nj-button"><i class="mdi mdi-file-pdf-box"></i>Adjuntar Firma</div>
                        </b-upload>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green"
                        @click="modificar()"><i class="mdi mdi-content-save"></i>Modificar</button>
            </template>
        </Box>
    </div>
</template>

<script>
import RolService from "../../services/RolService"
import Toast from "../../util/toast"
import { UsuarioService } from "../../services"
import TipoUsuario from "../../constants/tipoUsuario"
import { mapActions } from "vuex"
import { Box } from "../components"
import { AppService, ResponseStatus } from "../../services"

export default {
    name: "ModificarUsuario",
    components: {
        Box
    },
    props: {
        usu_id: null
    },
    data() {
        return {
            usuario: null,
            roles: [],
            puestos: [],
            tipos_usaurio: [],
            lista_usuario_nivel: [],
            id_roles: [],
            firma: null,
        }
    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        modificar() {
            let errors = 0
            this.id_roles.forEach(item => {
                this.usuario.lista_usuario_rol.push({
                    rol_id: item
                })
            })
            if (this.usuario.usu_nombre == null) errors++
            if (this.usuario.usu_apellido == null) errors++
            if (this.usuario.usu_dni == null) errors++
            if (this.usuario.usu_correo == null) errors++
            if (this.usuario.usu_password == null) errors++
            if (this.usuario.usu_nivel == null) errors++
            if (this.usuario.lista_usuario_rol.length == 0) errors++
            if (errors == 0) {
                UsuarioService.modificar(this.usuario).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar(true)
                        }
                        else {
                            Toast.error(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            } else {
                Toast.error("Faltan ingresar datos")
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        },
        adjuntarFirma() {
            this._loadingOn()
            let counter = 1
            let interval = setInterval(() => {
                counter++
                if (this.firma != null) {
                    UsuarioService.adjuntarFirma({
                        firma: this.firma,
                        usu_id: this.usuario.usu_id
                    }).then(
                        response => {
                            Toast.success(response.message)
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                    clearInterval(interval)
                }
                this.firma = null
                this._loadingOff()
            }, 1000)
        }
    },
    mounted() {
        // cargando los roles
        RolService.buscar().then(
            response => {
                this.roles = response.data
                UsuarioService.obtener({
                    usu_id: this.usu_id
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.usuario = response.data
                            // cargando tipos
                            this.tipos_usaurio.push(TipoUsuario.data.EMPLEADO)
                            this.usuario.tiu_id = 1
                            // cargando niveles
                            AppService
                                .getData(["niveles_usuario"])
                                .then(
                                    response => {
                                        if (ResponseStatus.isSuccess(response)) {
                                            this.lista_usuario_nivel = response.data.niveles_usuario
                                        }
                                        else {
                                            Toast.error(response.message)
                                        }
                                    },
                                    error => {
                                        Toast.error(error)
                                        console.error(`error: `, error)
                                    }
                                )
                            // cargando los roles que tiene hasta el momento el usuario
                            this.usuario.lista_usuario_rol.forEach(item => {
                                this.id_roles.push(item.rol_id)
                            })
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>